import FrozenAccount from './FrozenAccount';

export default FrozenAccount;
